export const PANEL_GUTTER = 16;
export const DEFAULT_PANEL_DIMENSIONS = { width: 488, height: 720 };
export const MINIMIZED_PANEL_DIMENSIONS = { width: 352, height: 48 };
export const MAXIMIZED_PANEL_DIMENSIONS = { width: 1098, height: 720 };
export const MAX_INPUT_LENGTH = 1000;
